var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AddRounded } from "@mui/icons-material";
import { Button, Grid, styled, Typography } from "@mui/material";
var TimeLineAddButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        background: "#444",
        borderRadius: "10px",
        "&:hover": { border: "2px solid ".concat(theme.palette.primary.light) },
    });
});
/**
virtus tech repo component check list:
  - is sx spread into root element of component for overrides and responsiveness flexability? yes
  - there's no margin on root element? yes, margin should be decided by consumer/user of component via sx override
  - does component have single clear responsability? yes, it renders an add scene icon button and text inside a root container
  - does component support dark and light theme? dark implemented but not yet light
  - have stories been written for component demonstrating different component states as a form -
    of documentation? yes
  - are controls for stories in/generated? yes - for stakeholders and developers to experiment with
  
**/
export default function VTTimelineAddScene(_a) {
    var _b = _a.title, title = _b === void 0 ? "Add Scene" : _b, _c = _a.size, size = _c === void 0 ? 80 : _c, _d = _a.titleTypographyVariant, titleTypographyVariant = _d === void 0 ? "body1" : _d, onClick = _a.onClick, sx = _a.sx;
    return (_jsxs(Grid, __assign({ container: true, sx: __assign({ width: size }, sx) }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sx: { justifyContent: "center", display: "flex" } }, { children: _jsx(TimeLineAddButton, __assign({ onClick: function () { return onClick && onClick(); }, sx: {
                        width: size - 5,
                        height: size - 5,
                        transition: ".5s",
                        ":hover": {
                            cursor: "pointer",
                            boxShadow: "0 0 25px #2ad5c7",
                        },
                    } }, { children: _jsxs(_Fragment, { children: [_jsx("svg", __assign({ width: 0, height: 0 }, { children: _jsxs("linearGradient", __assign({ id: "linearColors", x1: 1, y1: 0, x2: 1, y2: 1 }, { children: [_jsx("stop", { offset: 0, stopColor: "rgba(150,28,255,1)" }), _jsx("stop", { offset: 1, stopColor: "rgba(0,191,160,1)" })] })) })), _jsx(AddRounded, { sx: {
                                    width: "100%",
                                    height: "100%",
                                    fill: "url(#linearColors)",
                                } })] }) })) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: _jsx(Typography, __assign({ component: "div", variant: titleTypographyVariant, sx: {
                        textAlign: "center",
                        lineHeight: 1,
                        marginTop: "5px",
                    } }, { children: title })) }))] })));
}
